<template>
    <div v-loading="loading">
        <div class="margin-top-1 margin-bottom-1 ">
            <el-input type="textarea" :rows="20" v-model="content"></el-input>
            <div class="margin-top-2" style="text-align: center">
                <el-button title="导入" icon="el-icon-fa-check" class="green" @click="exec">导入</el-button>
                <el-button title="格式化" icon="el-icon-fa-reorder" class="blue" @click="format">格式化</el-button>
                <el-button title="示例" icon="el-icon-info" class="blue" @click="handleShow"> 示例</el-button>
            </div>
        </div>
        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="show" title="模板示例" width="600px">
            <ConnMould v-if="show" ref="edit"></ConnMould>
        </el-dialog>
    </div>
</template>


<script>
import ConnApi from "./Conn";
import ConnMould from "./ConnMould";

export default {
    components: {ConnMould},
    data() {
        return {
            show: false,
            loading:false,
            content: ""
        };
    },
    methods: {
        handleShow() {
            this.show = true;
        },
        format() {
            let a = this.content;
            try {
                this.content = JSON.stringify(JSON.parse(a), null, 2);
            } catch ( e ) {
                this.$message.error("JSON格式错误!");
                return false;
            }
            return true;
        },
        async exec() {
            let status = this.format();
            if (status) {
                try {
                    this.loading = true;
                    await ConnApi.connImport(this.content);
                    this.$emit("upd");
                } finally {
                    this.loading = false;
                }
            }
        },
    }
};
</script>